"use client";

import { Separator } from "@/components/ui/separator";
import { type CamundaTask } from "@/lib/camunda";
import { TaskAssignmentButton } from "./task-assignment-button";

interface TaskHeaderProps {
  task: CamundaTask;
}

export function TaskHeader({ task }: TaskHeaderProps) {
  return (
    <>
      <div className="bg-white px-4 py-4 h-20 flex items-center">
        <div className="flex items-center justify-between w-full">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {task.name || 'Tarea sin nombre'}
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              {task.processDefinitionName}
            </p>
          </div>
          
          <div className="flex items-center space-x-3">
          <TaskAssignmentButton task={task} />
          </div>
        </div>
      </div>
      <Separator className="h-px bg-gray-200" />
    </>
  );
}
